"use client";
import React from "react";

import { Box, BoxSx } from "../../foundations";
import { getIsMarkerInRange } from "./helpers";
import { SliderPropsWithDefaults } from "./types";

interface SliderMarkerProps {
  markerIndex: number;
  markersTotal: number;
  slider: SliderPropsWithDefaults;
}

export const SliderMarker: React.FC<SliderMarkerProps> = ({
  markerIndex,
  markersTotal,
  slider
}) => {
  const left = React.useCallback<Extract<BoxSx["left"], Function>>(
    ({ sizes }) => {
      if (markerIndex === 0) {
        return `${sizes[1] / 2}px`;
      } else if (markerIndex === markersTotal - 1) {
        return `calc(${(markerIndex / (markersTotal - 1)) * 100}% - ${sizes[1] + sizes[1] / 2}px)`;
      } else {
        return `calc(${(markerIndex / (markersTotal - 1)) * 100}% - ${sizes[1] / 2}px)`;
      }
    },
    [markerIndex, markersTotal]
  );

  return (
    <Box
      as="span"
      sx={{
        backgroundColor: getIsMarkerInRange(
          slider.value,
          slider.min,
          slider.max,
          slider.step,
          markerIndex
        )
          ? "slider-onsurface-selected"
          : "slider-onsurface-notselected",
        borderRadius: "radius-1",
        display: "block",
        height: 1,
        left,
        position: "absolute",
        top: ({ sizes }) => `${sizes[3] + sizes[1] / 2}px`,
        width: 1
      }}
    />
  );
};
